<template>
  <div class="BC-container">
    <div class="BC-right-container">
      <div class="container">
        <h3>新机/准新机条形码打印：</h3>
        <div class="floating-link">
          <a href="https://mangkeyi.yuque.com/tluy7x/rpi080/gvgq8h9wpvf9d3cp" target="_blank">使用教程</a>
        </div>
        <el-form ref="phoneForm" :rules="rules" :model="phoneForm" label-width="100px" style="padding: 20px">
          <!-- 使用 gutter 属性增加列之间的间距 -->
          <el-row :gutter="195" style="margin-left: -100px">
            <el-col :span="12">
              <el-form-item label="手机分类" prop="phoneClassification">
                <el-radio-group v-model="phoneForm.phoneClassification" style="margin-left: -50px" text-color="#FB9337"
                  fill="#FB9337">
                  <el-radio label="新机"></el-radio>
                  <el-radio label="准新机"></el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="手机品牌" prop="phoneBrand">
                <el-select v-model="phoneForm.phoneBrand" style="margin-left: 20px">
                  <el-option v-for="(data, index) in Array.from(
                    new Set(this.phoneBrandList)
                  )" :key="index" :value="data" :label="data" class="input"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="型号" prop="phoneName">
                <el-select style="margin-left: 20px" v-el-select-loadmore="selectLoadMoreSnInfo"
                  v-model="phoneForm.phoneName" @change="queryPhoneColorList">
                  <el-option v-for="(data, index) in Array.from(
                    new Set(this.phoneNameList)
                  )" :key="index" :value="data" :label="data"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="颜色" prop="phoneColor">
                <el-select v-model="phoneForm.phoneColor" style="margin-left: 20px">
                  <el-option v-for="(data, index) in Array.from(
                    new Set(this.phoneColorList)
                  )" :key="index" :value="data" :label="data"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="内存" prop="phoneMemory">
                <el-select v-model="phoneForm.phoneMemory" style="margin-left: 20px">
                  <el-option v-for="(data, index) in Array.from(
                    new Set(this.phoneMemoryList)
                  )" :key="index" :value="data" :label="data"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="运行内存">
                <el-select v-model="phoneForm.phoneRuningMemory" style="margin-left: 20px; position: relative; z-index: 1000">
                  <el-option v-for="(data, index) in Array.from(
                    new Set(this.phoneRuningMemoryList)
                  )" :key="index" :value="data" :label="data"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="机器类型" prop="phoneType">
                <el-select v-model="phoneForm.phoneType" style="margin-left: 20px">
                  <el-option v-for="(data, index) in phoneTypeList" :key="index" :value="data" :label="data"
                    class="input"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="机器版本" prop="phoneVersion">
                <el-select v-model="phoneForm.phoneVersion" style="margin-left: 20px">
                  <el-option v-for="(data, index) in phoneVersionList" :key="index" :value="data" :label="data"
                    class="input"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="售后保障" prop="salesGuarantee">
                <el-select v-model="phoneForm.salesGuarantee" style="margin-left: 20px">
                  <el-option v-for="(data, index) in phoneGuaranteeList" :key="index" :value="data" :label="data"
                    class="input"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否有锁" prop="IsLock">
                <el-radio-group v-model="phoneForm.IsLock" style="margin-left: -60px">
                  <el-radio label="有锁"></el-radio>
                  <el-radio label="无锁"></el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="供应商名称" prop="Supplier">
                <el-select v-model="phoneForm.Supplier" style="margin-left: 20px">
                  <el-option v-for="(data, index) in Array.from(
                    new Set(this.SupplierList)
                  )" :key="index" :value="data" :label="data"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-row style="text-align: right">
          <el-col :span="24" style="margin-top: -70px; margin-left: -20px">
            <el-button style="width: 150px; height: 40px" @click="toScan" type="primary"
              size="small">扫描手机条形码</el-button>
            <!-- <el-button @click="toWarehousing" type="primary" size="small">入库</el-button> -->
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog title="入库" :visible.sync="warehousingVisible" width="50%" :before-close="handleClose">
      <div>
        <el-input type="textarea" :rows="12" v-model="phoneStorageIn"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="warehousingVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitPhoneStorage">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="扫描手机条形码" :visible.sync="scanVisible" width="50%" :before-close="handleCloseScan">
      <div>
        <!-- <el-input :rows="12" v-model="scanBarcodeIn" type="textarea"></el-input> -->
        <el-input style="margin-top: 10px;" type="textarea" :rows="3" v-for="(input, index) in inputs" :key="index"
          v-model="input.value" @change="handleInput(index, $event)"></el-input>
        <el-row style="margin-top: 5px">
          <el-col :span="24" class="text-right">
            <el-link type="danger" href="https://mangkeyi.yuque.com/tluy7x/rpi080/tdvb9p9x2z6k7ezq?singleDoc#"
              target="_blank">扫描枪使用说明书</el-link>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseScan">取 消</el-button>
        <el-button type="primary" @click="showImage">扫描设置</el-button>
        <el-button type="primary" @click="submitScanPhoneData(batchPrintPhoneData)"
          v-loading.fullscreen.lock="fullscreenLoading">打印并提交</el-button>
      </span>
    </el-dialog>
    <el-dialog fullscreen :visible.sync="scanSettingVisible">
      <el-image :src="imageUrl" fit="contain">
      </el-image>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import Socket from "@/utils/Socket";
import NMPrintSocket from "@/utils/Print";
import { batchPrintPhoneData } from "@/utils/printData/newPhone";
import { batchPrintData } from "@/utils/printData/Batch";
export default {
  //创建自定义事件
  directives: {
    "el-select-loadmore": {
      bind(el, binding) {
        const SELECTWRAP_DOM = el.querySelector(
          ".el-select-dropdown .el-select-dropdown__wrap"
        );
        SELECTWRAP_DOM.addEventListener("scroll", function () {
          const rect = this.getBoundingClientRect();
          const isAtBottom = rect.bottom <= window.innerHeight;
          if (isAtBottom) {
            binding.value();
          }
        });
      },
    },
  },
  data() {
    const jsonObj = {
      printerImageProcessingInfo: {
        printQuantity: 1,
      },
    };
    return {
      userId: 1940693,
      IMEIArry: [],
      imageUrl: '',
      scanSettingVisible: false,
      inputs: [{ value: '' }],
      scanArry: [],
      fullscreenLoading: false,
      currentPage: 1,
      pageSize: 200,
      pageAmount: 1,
      SupplierList: [],
      phoneForm: {
        IsLock: "无锁",
      },
      phoneNameList: [],
      phoneBrandList: [],
      phoneColorList: [],
      phoneMemoryList: [],
      fitType: "",
      barCodeNum: "",
      warehousingVisible: false,
      scanVisible: false,
      scanBarcodeIn: "",
      scanPhonecode: "",
      jsonObj,
      // 打印服务是否连接成功
      printSocketOpen: false,
      batchPrintPhoneData,
      batchPrintData,
      barCodeList: [],
      barCodePrintList: [],
      NPQRCodePrintList: [],
      phoneStorageIn: [],
      barcodePrintFlag: false,
      nMPrintSocket: null,
      usbPrinters: {},
      usbSelectPrinter: "",
      onlineUsbBool: false,
      initBool: false,
      responseflag: false,
      density: 3,
      label_type: 1,
      print_mode: 1,
      phoneRuningMemoryList: [],
      phoneGuaranteeList: ["店保", "第三方保修", "官保"],
      phoneVersionList: ["国行", "美版", "欧版", "港版", "日版", "其它版本"],
      phoneTypeList: [
        "零售机",
        "资源机",
        "权益机",
        "演示机",
        "官换机",
        "官翻机",
        "卡贴机",
        "其他类型",
      ],
      rules: {
        phoneType: [
          { required: true, message: "请选择手机类型", trigger: "change" },
        ],
        phoneBrand: [
          { required: true, message: "请选择手机品牌", trigger: "change" },
        ],
        phoneName: [
          { required: true, message: "请选择手机型号", trigger: "change" },
        ],
        phoneColor: [
          { required: true, message: "请选择手机颜色", trigger: "change" },
        ],
        phoneMemory: [
          { required: true, message: "请选择手机内存", trigger: "change" },
        ],
        Supplier: [
          { required: true, message: "请选择供应商", trigger: "change" },
        ],
      },
    };
  },
  mounted() {
    // 创建socket实例
    const socketData = new Socket("ws://127.0.0.1:37989");

    socketData.open(
      (openBool) => {
        console.log(openBool, "openBool");
        this.printSocketOpen = openBool;
      },
      (msg) => {
        if (msg.resultAck.callback != undefined) {
          const callbackName = msg.resultAck.callback.name;
          const msgInfo = msg.resultAck.info;
          if (callbackName == "onCoverStatusChange") {
            //盒盖状态：0-闭合、1-打开
            console.log("盒盖状态", msgInfo.capStatus);
          } else if (callbackName == "onElectricityChange") {
            //"power" : 0-4, // 电池电量等级（共5档）
            console.log("电池电量等级", msgInfo.power);
          }
        }
      }
    );
    // 创建打印实例
    this.nMPrintSocket = new NMPrintSocket(socketData);
  },
  created() {
    this.login();

  },
  methods: {
    login() {
      const currentUrl = window.location.toString();
      const urlObject = new URL(currentUrl);
      const searchParams = new URLSearchParams(urlObject.search);
      const userId = searchParams.get("qfExtUserId");
      if (userId != null || userId != undefined) {
        this.userId = userId;
      }
      console.log(this.userId);
      // 创建一个新的 Axios 实例专用于 /orderListApi 请求
      const loginApiInstance = axios.create({
        baseURL: "/loginApi",
      });
      //使用FormData对象发送POST请求
      loginApiInstance
        .get("monkeyshop/user/login/" + this.userId)
        .then((res) => {
          // this.tableData = res.data.data;
          if (res.data.code == 200) {
            this.obtainPhoneInfo();
            this.obtainSupplierInfo();
          } else {
            alert(res.data.msg);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handleCloseScan() {
      this.scanVisible = false
      this.inputs = [{ value: '' }]
    },
    showImage() {
      // 使用 require 动态引入图片
      this.imageUrl = require('@/assets/scanSetting.png');
      this.scanSettingVisible = true;
    },
    handleInput(index, event) {
      this.inputs.push({ value: '' })
      console.log(this.inputs, 'inputs')
      this.scanArry.push(this.inputs[index].value)
      console.log(this.scanArry, 'scanArry')
    },
    // 下拉列表触底事件
    selectLoadMoreSnInfo() {
      console.log("下拉框到底触发");
      this.currentPage += 1;
      this.obtainPhoneInfo();
    },
    async print(content) {
      this.fullscreenLoading = true;
      const allPrintersRes = await this.nMPrintSocket.getAllPrinters();
      console.log(allPrintersRes, "allPrintersRes");
      try {
        // const { errorCode, info } = JSON.parse(JSON.stringify(data)).resultAck;
        if (allPrintersRes.resultAck.errorCode === 0) {
          const allPrinters = JSON.parse(allPrintersRes.resultAck.info);
          const allPrintersName = Object.keys(allPrinters);
          const allPrintersValue = Object.values(allPrinters);
          console.log(allPrinters, "allPrinters");
          console.log(
            allPrintersName[0],
            allPrintersValue[0],
            "allPrintersName[0]",
            "allPrinters[0]"
          );
          const res = await this.nMPrintSocket.selectPrinter(
            allPrintersName[0],
            parseInt(allPrintersValue[0])
          );
          console.log("选择打印机", res);

          if (res.resultAck.errorCode === 0) {
            console.log("连接成功");
            const initRes = await this.nMPrintSocket.initSdk({ fontDir: "" });
            if (initRes.resultAck.errorCode == 0) {
              console.log("初始化成功");
              this.startBatchPrintJobTest(content);
            } else {
              this.fullscreenLoading = false
              this.$notify.error({
                title: '错误',
                message: '初始化失败'
              });
              console.log("初始化失败");
            }
          } else {
            this.fullscreenLoading = false
            this.$notify.error({
              title: '错误',
              message: '连接失败'
            });
            console.log("连接失败");
            // alert("连接失败");
          }
        } else {
          this.fullscreenLoading = false
          return alert("没有在线的打印机");
        }
      } catch (err) {
        return alert(err);
      }
    },
    obtainSupplierInfo() {
      this.SupplierList = [];
      const searchSuppliers = axios.create({
        baseURL: "/colorListApi",
        "Content-Type": "application/json",
      });
      searchSuppliers
        .post("monkeyshop/common/searchSuppliers?userId=" + this.userId)
        .then((res) => {
          res.data.data.forEach((element) => {
            this.SupplierList.push(element)
          });
        })

    },
    //更新打印机列表
    async getPrinters() {
      if (!this.printSocketOpen) {
        this.fullscreenLoading = false
        return alert("打印服务未开启");
      }
      console.log("开始获取打印机");
      try {
        const allPrintersRes = await this.nMPrintSocket.getAllPrinters();
        console.log(allPrintersRes, "allPrintersRes");
        if (allPrintersRes.resultAck.errorCode === 0) {
          const allPrinters = JSON.parse(allPrintersRes.resultAck.info);
          this.usbPrinters = { ...allPrinters };
          this.usbSelectPrinter = Object.keys(this.usbPrinters)[0];
          console.log("printers", this.usbPrinters);
        } else {
          this.fullscreenLoading = false
          this.$notify.error({
            title: '错误',
            message: '没有在线的打印机'
          });
          // alert("没有在线的打印机");
        }
      } catch (err) {
        console.error(err);
      }
    },
    // 连接打印机
    async selectOnLineUsbPrinter() {
      if (!this.printSocketOpen) {
        this.fullscreenLoading = false
        return alert("打印服务未开启");
      }
      console.log("开始连接打印机");
      try {
        const res = await this.nMPrintSocket.selectPrinter(
          this.usbSelectPrinter,
          parseInt(this.usbPrinters[this.usbSelectPrinter])
        );
        console.log("选择打印机", res);

        if (res.resultAck.errorCode === 0) {
          console.log("连接成功");
          this.onlineUsbBool = true;
        } else {
          console.log("连接失败");
          this.onlineUsbBool = false;
          this.fullscreenLoading = false
          this.$notify.error({
            title: '错误',
            message: '连接失败'
          });
          // alert("连接失败");
        }
      } catch (err) {
        console.error(err);
      }
    },
    //初始化SDK
    async init() {
      if (!this.printSocketOpen) return alert("打印服务未开启");
      //初始化数据
      try {
        const res = await this.nMPrintSocket.initSdk({ fontDir: "" });
        if (res.resultAck.errorCode == 0) {
          console.log("初始化成功");
          this.initBool = true;
        } else {
          console.log("初始化失败");
          this.initBool = false;
          this.fullscreenLoading = false
          this.$notify.error({
            title: '错误',
            message: '初始化失败'
          });
        }
      } catch (err) {
        console.error(err);
      }
    },
    // 开始批量打印
    async startBatchPrintJobTest(content) {
      console.log(content, "content");
      // console.log(this.batchPrintData.data,'batchPrintData')
      // this.batchPrintData.data = content
      if (!this.printSocketOpen) return alert("打印服务未开启");
      if (content == null || content.length == 0) {
        return;
      }
      this.batchPrintJob(content.data);
    },
    //批量打印列表数据
    async batchPrintJob(list) {
      // console.log()
      const printQuantity =
        this.jsonObj.printerImageProcessingInfo.printQuantity;
      console.log(printQuantity, "printQuantity");
      console.log(list.length, "list");
      try {
        const startRes = await this.nMPrintSocket.startJob(
          this.density,
          this.label_type,
          this.print_mode,
          list.length * printQuantity
        );
        if (startRes.resultAck.errorCode == 0) {
          // 提交打印任务
          await this.printTag(list, 0);
        }
      } catch (err) {
        console.error(err);
      }
    },
    // 绘制打印标签
    async printTag(list, x) {
      console.log(list, x);
      //设置画布尺寸
      try {
        const res = await this.nMPrintSocket.InitDrawingBoard(
          list[x].InitDrawingBoardParam
        );
        if (res.resultAck.errorCode != 0) {
          return;
        }
        // 提交打印任务
        this.printItem(list, x, list[x].elements, 0);
      } catch (err) {
        console.error(err);
      }
    },
    async printItem(list, x, item, i) {
      try {
        if (i < item.length) {
          let arrParse;
          switch (item[i].type) {
            case "text":
              //绘制文本
              arrParse = await this.nMPrintSocket.DrawLableText(item[i].json);
              if (arrParse.resultAck.errorCode != 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i);
              break;
            case "qrCode":
              arrParse = await this.nMPrintSocket.DrawLableQrCode(item[i].json);
              //绘制二维码
              if (arrParse.resultAck.errorCode !== 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i);
              break;
            case "barCode":
              //绘制一维码
              arrParse = await this.nMPrintSocket.DrawLableBarCode(
                item[i].json
              );
              if (arrParse.resultAck.errorCode !== 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item);
              break;
            case "line":
              //绘制线条
              arrParse = await this.nMPrintSocket.DrawLableLine(item[i].json);
              if (arrParse.resultAck.errorCode !== 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i);
              break;
            case "graph":
              //绘制边框
              arrParse = await this.nMPrintSocket.DrawLableGraph(item[i].json);
              if (arrParse.resultAck.errorCode != 0) {
                return;
              }

              i++;
              await this.printItem(list, x, item, i);
              break;
            case "image":
              //绘制边框
              arrParse = await this.nMPrintSocket.DrawLableImage(item[i].json);
              if (arrParse.resultAck.errorCode != 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i);
              break;
          }
        } else {
          //遍历完成，开始打印
          const commitRes = await this.nMPrintSocket.commitJob(
            null,
            JSON.stringify(this.jsonObj)
          );
          //回调页码为数据总长度且回调打印份数数据等于当前页需要打印的份数数据时，结束打印任务
          if (
            commitRes.resultAck.printQuantity == list.length &&
            commitRes.resultAck.onPrintPageCompleted ==
            this.jsonObj.printerImageProcessingInfo.printQuantity
          ) {
            //结束打印任务
            const endRes = await this.nMPrintSocket.endJob();
            if (endRes.resultAck.errorCode === 0) {
              console.log("打印完成");
              this.scanVisible = false;
              this.phoneForm = {};
              this.scanBarcodeIn = "";
              this.$set(this.phoneForm, "IsLock", "无锁");
              this.fullscreenLoading = false
              this.$nextTick(() => {
                this.$refs["phoneForm"].clearValidate();
              });
              this.$forceUpdate();
              // this.submitPhoneData();
              // this.scanVisible = false;
              // this.phoneForm.IsLock = "无锁";
              // this.submitScanInData()
            }
            return;
          }
          //回调为提交成功，同时数据未发送完成时，可继续提交数据
          if (commitRes.resultAck.errorCode === 0 && x < list.length - 1) {
            //数据提交成功，数据下标+1
            console.log("发送下一页打印数据： ");
            x++;
            await this.printTag(list, x);
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
    toWarehousing() {
      this.warehousingVisible = true;
    },
    toScan() {
      console.log(this.phoneForm, 'phoneform')
      this.scanVisible = true;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
    obtainPhoneInfo() {
      console.log("执行了嘛");
      if (this.currentPage <= this.pageAmount) {
        let params = {
          userId: this.userId,
          pageSize: this.pageSize,
          pageNum: this.currentPage,
        };
        const searchPhoneInfo = axios.create({
          baseURL: "/colorListApi",
          "Content-Type": "application/json",
        });
        searchPhoneInfo
          .post("monkeyshop/common/searchPhoneInfo", params)
          .then((res) => {
            console.log(res);
            this.pageAmount = res.data.data.pageAmount;
            res.data.data.phoneNameList.forEach((element) => {
              this.phoneNameList.push(element);
            });
            res.data.data.phoneMemoryList.forEach((element) => {
              this.phoneMemoryList.push(element);
            });
            res.data.data.phoneBrandList.forEach((element) => {
              this.phoneBrandList.push(element);
            });
            res.data.data.phoneRuningMemoryList.forEach((element) => {
              this.phoneRuningMemoryList.push(element);
            });
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    queryPhoneColorList() {
      console.log(this.phoneForm.phoneName, "选择型号");
      // 创建一个新的 Axios 实例专用于 /colorListApi 请求
      const colorListApiInstance = axios.create({
        baseURL: "/colorListApi",
        // headers: {
        //     'Content-Type': 'multipart/form-data'
        // }
      });
      //使用FormData对象发送POST请求
      colorListApiInstance
        .post(
          "monkeyshop/common/searchPhoneColorByModel" +
          "?" +
          "modelName" +
          "=" +
          this.phoneForm.phoneName + "&userId=" +
          this.userId
        )
        .then((res) => {
          console.log(res, "res");
          this.phoneColorList = res.data.data.colors;
          // this.tableData = res.data.
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    submitPhoneStorage() {
      var that = this;
      console.log(that.phoneStorageIn, "this.phoneStorageIn");
      const PhoneSI = that.phoneStorageIn.split("\n");
      // PhoneSI.splice(PhoneSI.length - 1, 1);
      const onePhoneSIArr = Array.from(new Set(PhoneSI));
      const onePhoneSI = onePhoneSIArr.filter((item) => item !== "");
      console.log(onePhoneSI, 'onePhoneSI')
      axios({
        method: "post",
        url: "openApi/app/5u91so0c1801/apply/filter",
        data: {
          pageSize: 200,
          pageNum: 1,
        },
        headers: {
          "Content-Type": "application/json",
          accessToken: "62b6c5b8-dd44-4f4e-8f95-865d45189bb3",
        },
        withCredentials: true,
      })
        .then((res) => {
          console.log(res, "res");
          let applyIdList = res.data.result.result;
          // console.log(applyIdList,'---applyIdList')
          for (var i = 0; i < applyIdList.length; i++) {
            // console.log(applyIdList[i],'-----item----')
            // console.log(applyIdList[i].applyId,'-----applyId----')
            let oneApplyID = applyIdList[i].applyId;
            let answersList = applyIdList[i].answers;
            for (var index = 0; index < answersList.length; index++) {
              // console.log(answersList[index],'answer')
              if (answersList[index].queId == 182383141) {
                // console.log(answersList[index].values[0].value,'-----queID=0itemvalue----')
                if (onePhoneSI.includes(answersList[index].values[0].value)) {
                  console.log("元素在扫描到的数组中");
                  axios({
                    method: "post",
                    url: "openApi/apply/" + oneApplyID,
                    data: {
                      answers: [
                        { queId: 182383150, values: [{ value: "在库" }] },
                      ],
                    },
                    headers: {
                      accessToken: "62b6c5b8-dd44-4f4e-8f95-865d45189bb3",
                      "Content-Type": "application/json",
                    },
                    withCredentials: true,
                  })
                    .then((response) => {
                      that.$message({
                        message: "入库成功",
                        type: "success",
                      });
                    })
                    .catch(function (error) {
                      console.log(error);
                    });
                } else {
                  console.log("元素不在扫描到的数组中");
                }
                that.warehousingVisible = false;
              }
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    submitScanPhoneData() {
      const loginApiInstance = axios.create({
        baseURL: "/loginApi",
        "Content-Type": "application/json",
      });
      let params = {
        isLock: this.phoneForm.isLock,
        supplier: this.phoneForm.supplier,
        phoneBrand: this.phoneForm.phoneBrand,
        phoneClassification: this.phoneForm.phoneClassification,
        phoneMemory: this.phoneForm.phoneMemory,
        phoneRuningMemory:this.phoneForm.phoneRuningMemory,
        phoneColor: this.phoneForm.phoneColor,
        phoneName: this.phoneForm.phoneName,
        phoneType: this.phoneForm.phoneType,
        phoneVersion: this.phoneForm.phoneVersion,
        salesGuarantee: this.phoneForm.salesGuarantee,
        phoneList: this.scanArry,
        email: this.userId,
      };
      loginApiInstance
        .post("monkeyshop/common/newPhone", params)
        .then((res) => {
          this.IMEIArry = res.data.data
          console.log(res.data.data, "新机res");
          var that = this;
          that.NPQRCodePrintList = [];
          const PhonecodeArr = Array.from(new Set(that.IMEIArry));
          const onePhonecode = PhonecodeArr.filter((item) => item !== "");
          onePhonecode.forEach((element) => {
            const printQRData = {
              InitDrawingBoardParam: {
                width: 50,
                height: 70,
                rotate: 0,
                path: "ZT001.ttf",
                verticalShift: 0,
                HorizontalShift: 0,
              },

              elements: [
                {
                  type: "text",
                  json: {
                    x: 2,
                    y: 2,
                    height: 7.4,
                    width: 36,
                    value: "新机入库标签",
                    fontFamily: "宋体",
                    rotate: 0,
                    fontSize: 5.6,
                    textAlignHorizonral: 1,
                    textAlignVertical: 1,
                    letterSpacing: 0,
                    lineSpacing: 1,
                    lineMode: 6,
                    fontStyle: [true, false, false, false],
                  },
                },
                {
                  type: "text",
                  json: {
                    x: 3,
                    y: 11,
                    height: 4.3,
                    width: 34,
                    value: "手机品牌：苹果",
                    fontFamily: "宋体",
                    rotate: 0,
                    fontSize: 3.2,
                    textAlignHorizonral: 0,
                    textAlignVertical: 1,
                    letterSpacing: 0,
                    lineSpacing: 1,
                    lineMode: 6,
                    fontStyle: [false, false, false, false],
                  },
                },
                {
                  type: "text",
                  json: {
                    x: 3,
                    y: 17,
                    height: 4.3,
                    width: 34,
                    value: "机型名称：iPhone 18 Pro",
                    fontFamily: "宋体",
                    rotate: 0,
                    fontSize: 3.2,
                    textAlignHorizonral: 0,
                    textAlignVertical: 1,
                    letterSpacing: 0,
                    lineSpacing: 1,
                    lineMode: 6,
                    fontStyle: [false, false, false, false],
                  },
                },
                {
                  type: "text",
                  json: {
                    x: 3,
                    y: 23,
                    height: 4.3,
                    width: 34,
                    value: "内存：512G",
                    fontFamily: "宋体",
                    rotate: 0,
                    fontSize: 3.2,
                    textAlignHorizonral: 0,
                    textAlignVertical: 1,
                    letterSpacing: 0,
                    lineSpacing: 1,
                    lineMode: 6,
                    fontStyle: [false, false, false, false],
                  },
                },
                {
                  type: "text",
                  json: {
                    x: 3,
                    y: 29,
                    height: 4.3,
                    width: 34,
                    value: "颜色：远峰蓝",
                    fontFamily: "宋体",
                    rotate: 0,
                    fontSize: 3.2,
                    textAlignHorizonral: 0,
                    textAlignVertical: 1,
                    letterSpacing: 0,
                    lineSpacing: 1,
                    lineMode: 6,
                    fontStyle: [false, false, false, false],
                  },
                },
                {
                  type: "qrCode",
                  json: {
                    x: 3,
                    y: 35,
                    height: 20,
                    width: 20,
                    value: "10000000",
                    codeType: 31,
                    rotate: 0,
                    fontSize: 3.2,
                    textHeight: 3.2,
                    textPosition: 0,
                  },
                },
              ],
            };
            if (that.phoneForm.phoneClassification == "新机") {
              printQRData.elements[0].json.value = "新机入库标签";
            }
            if (that.phoneForm.phoneClassification == "准新机") {
              printQRData.elements[0].json.value = "准新机入库标签";
            }
            printQRData.elements[1].json.value =
              "手机品牌：" + that.phoneForm.phoneBrand;
            printQRData.elements[2].json.value =
              "型号：" + that.phoneForm.phoneName;
            printQRData.elements[4].json.value =
              "颜色：" + that.phoneForm.phoneColor;
            printQRData.elements[3].json.value =
              "内存：" + that.phoneForm.phoneMemory;
            printQRData.elements[5].json.value = element;
            that.NPQRCodePrintList.push(printQRData);
            that.batchPrintPhoneData.data = that.NPQRCodePrintList;
            that.print(that.batchPrintPhoneData);
          });
        })
        .catch(function (error) {
          console.log(error);
        });


    },
    submitPhoneData() {
      var that = this;
      const Phonecode = that.scanBarcodeIn.split("\n");
      const phoneCodeList = Array.from(new Set(Phonecode));
      const onePhonecode = phoneCodeList.filter(item => item.trim() !== "");

      const phoneNum = onePhonecode.length;
      console.log(Phonecode, "Phonecode");
      console.log(phoneNum, "phoneNum");
      console.log(that.phoneForm, "phoneForm");
      // const onePhonecode = Array.from(new Set(Phonecode));
      axios({
        method: "post",
        url: "openApi/app/6n17no0k3o01/apply",
        data: {
          applyUser: {
            email: "",
          },
          answers: [
            {
              queId: 182395798,
              queTitle: "手机类型",
              queType: 2,
              values: [
                {
                  value: that.phoneForm.phoneClassification,
                },
              ],
            },
            {
              queId: 182395799,
              queTitle: "手机品牌",
              queType: 2,
              values: [
                {
                  value: that.phoneForm.phoneBrand,
                },
              ],
            },
            {
              queId: 182395800,
              queTitle: "手机型号",
              queType: 2,
              values: [
                {
                  value: that.phoneForm.phoneName,
                },
              ],
            },
            {
              queId: 182395801,
              queTitle: "颜色",
              queType: 2,
              values: [
                {
                  value: that.phoneForm.phoneColor,
                },
              ],
            },
            {
              queId: 182395802,
              queTitle: "内存",
              queType: 2,
              values: [
                {
                  value: that.phoneForm.phoneMemory,
                },
              ],
            },
            {
              queId: 182394428,
              queTitle: "份数",
              queType: 2,
              values: [
                {
                  value: phoneNum,
                },
              ],
            },
          ],
        },
        headers: {
          "Content-Type": "application/json",
          accessToken: "62b6c5b8-dd44-4f4e-8f95-865d45189bb3",
        },
        withCredentials: true,
      })
        .then((res) => {
          console.log(res, "res");
          const requestID = res.data.result.requestId;
          console.log(requestID, "requestID");
          axios({
            method: "get",
            url: "openApi/operation/" + requestID,
            headers: {
              "Content-Type": "application/json",
              accessToken: "62b6c5b8-dd44-4f4e-8f95-865d45189bb3",
            },
            withCredentials: true,
          })
            .then((res) => {
              axios({
                method: "get",
                url: "openApi/apply/" + res.data.result,
                headers: {
                  "Content-Type": "application/json",
                  accessToken: "62b6c5b8-dd44-4f4e-8f95-865d45189bb3",
                },
                withCredentials: true,
              }).then((res) => {
                console.log(res.data.result, "编号信息");
                let dataValueForQueId0 = "";
                res.data.result.answers.forEach((element) => {
                  if (element.queId === 0) {
                    dataValueForQueId0 = element.values[0].dataValue;
                    console.log(dataValueForQueId0, "编号号码");
                  }
                });
                onePhonecode.forEach((element) => {
                  console.log(element, "element");
                  console.log(that.phoneForm, "新机还是准新机");
                  if (that.phoneForm.phoneClassification == "新机") {
                    axios({
                      method: "post",
                      url: "openApi/app/5u91so0c1801/apply",
                      data: {
                        applyUser: {
                          email: "",
                        },
                        answers: [
                          {
                            queId: 182392813,
                            queTitle: "手机分类",
                            queType: 10,
                            values: [
                              {
                                value: "新机",
                              },
                            ],
                          },
                          {
                            queId: 182392815,
                            queTitle: "手机品牌",
                            queType: 19,
                            values: [
                              {
                                value: that.phoneForm.phoneBrand,
                              },
                            ],
                          },
                          {
                            queId: 182383149,
                            queTitle: "机型名称",
                            queType: 19,
                            values: [
                              {
                                value: that.phoneForm.phoneName,
                              },
                            ],
                          },
                          {
                            queId: 182383143,
                            queTitle: "手机颜色",
                            queType: 19,
                            values: [
                              {
                                value: that.phoneForm.phoneColor,
                              },
                            ],
                          },
                          {
                            queId: 182383145,
                            queTitle: "内存",
                            queType: 19,
                            values: [
                              {
                                value: that.phoneForm.phoneMemory,
                              },
                            ],
                          },
                          {
                            queId: 182383141,
                            queTitle: "SN码",
                            queType: 2,
                            values: [
                              {
                                value: element,
                              },
                            ],
                          },
                          {
                            queId: 182394325,
                            queTitle: "批次编号",
                            queType: 2,
                            values: [
                              {
                                value: dataValueForQueId0,
                              },
                            ],
                          },
                          {
                            queId: 182392817,
                            queTitle: "是否有锁",
                            queType: 10,
                            values: [
                              {
                                value: that.phoneForm.IsLock,
                              },
                            ],
                          },
                          {
                            queId: 182392816,
                            queTitle: "机器类型",
                            queType: 11,
                            values: [
                              {
                                value: that.phoneForm.phoneType,
                              },
                            ],
                          },
                          {
                            queId: 182392818,
                            queTitle: "机器版本",
                            queType: 11,
                            values: [
                              {
                                value: that.phoneForm.phoneVersion,
                              },
                            ],
                          },
                          {
                            queId: 182392819,
                            queTitle: "售后保障",
                            queType: 11,
                            values: [
                              {
                                value: that.phoneForm.salesGuarantee,
                              },
                            ],
                          },
                          {
                            queId: 182383144,
                            queTitle: "运行内存",
                            queType: 19,
                            values: [
                              {
                                value: that.phoneForm.phoneRuningMemory,
                              },
                            ],
                          },
                          {
                            queId: 182394289,
                            queTitle: "供应商名称",
                            queType: 19,
                            values: [
                              {
                                value: that.phoneForm.Supplier,
                              },
                            ],
                          },
                        ],
                      },
                      headers: {
                        accessToken: "62b6c5b8-dd44-4f4e-8f95-865d45189bb3",
                        "Content-Type": "application/json",
                      },
                    })
                      .then((res) => {
                        console.log(res, "res提交到手机库存管理");
                        // that.phoneForm = {}
                        this.$nextTick(() => {
                          this.$refs["phoneForm"].clearValidate();
                        });
                        this.$forceUpdate();
                      })
                      .catch(function (error) {
                        console.log(error);
                      });
                  }
                  if (that.phoneForm.phoneClassification === "准新机") {
                    axios({
                      method: "post",
                      url: "openApi/app/5u91so0c1801/apply",
                      data: {
                        applyUser: {
                          email: "",
                        },
                        answers: [
                          {
                            queId: 182392813,
                            queTitle: "手机分类",
                            queType: 10,
                            values: [
                              {
                                value: "准新机",
                              },
                            ],
                          },
                          {
                            queId: 182392815,
                            queTitle: "手机品牌",
                            queType: 19,
                            values: [
                              {
                                value: that.phoneForm.phoneBrand,
                              },
                            ],
                          },
                          {
                            queId: 182383149,
                            queTitle: "机型名称",
                            queType: 19,
                            values: [
                              {
                                value: that.phoneForm.phoneName,
                              },
                            ],
                          },
                          {
                            queId: 182383143,
                            queTitle: "手机颜色",
                            queType: 19,
                            values: [
                              {
                                value: that.phoneForm.phoneColor,
                              },
                            ],
                          },
                          {
                            queId: 182383145,
                            queTitle: "内存",
                            queType: 19,
                            values: [
                              {
                                value: that.phoneForm.phoneMemory,
                              },
                            ],
                          },
                          {
                            queId: 182383141,
                            queTitle: "SN码",
                            queType: 2,
                            values: [
                              {
                                value: element,
                              },
                            ],
                          },
                          {
                            queId: 182394325,
                            queTitle: "批次编号",
                            queType: 2,
                            values: [
                              {
                                value: dataValueForQueId0,
                              },
                            ],
                          },
                          {
                            queId: 182392817,
                            queTitle: "是否有锁",
                            queType: 10,
                            values: [
                              {
                                value: that.phoneForm.IsLock,
                              },
                            ],
                          },
                          {
                            queId: 182392816,
                            queTitle: "机器类型",
                            queType: 11,
                            values: [
                              {
                                value: that.phoneForm.phoneType,
                              },
                            ],
                          },
                          {
                            queId: 182392818,
                            queTitle: "机器版本",
                            queType: 11,
                            values: [
                              {
                                value: that.phoneForm.phoneVersion,
                              },
                            ],
                          },
                          {
                            queId: 182392819,
                            queTitle: "售后保障",
                            queType: 11,
                            values: [
                              {
                                value: that.phoneForm.salesGuarantee,
                              },
                            ],
                          },
                          {
                            queId: 182383144,
                            queTitle: "运行内存",
                            queType: 19,
                            values: [
                              {
                                value: that.phoneForm.phoneRuningMemory,
                              },
                            ],
                          },
                          {
                            queId: 182394289,
                            queTitle: "供应商名称",
                            queType: 19,
                            values: [
                              {
                                value: that.phoneForm.Supplier,
                              },
                            ],
                          },
                        ],
                      },
                      headers: {
                        accessToken: "62b6c5b8-dd44-4f4e-8f95-865d45189bb3",
                        "Content-Type": "application/json",
                      },
                    })
                      .then((res) => {
                        that.$nextTick(() => {
                          that.$refs["phoneForm"].clearValidate();
                        });
                        that.$forceUpdate();
                        console.log(res, "res提交到手机库存管理");
                        // this.$message({
                        //     showClose: true,
                        //     message: '新机信息提交成功',
                        //     type: 'success'
                        // });
                      })
                      .catch(function (error) {
                        console.log(error);
                      });
                  }
                });
                if (that.phoneForm.phoneClassification == "新机") {
                  that.scanVisible = false;
                  that.phoneForm = {};
                  that.scanBarcodeIn = "";
                  that.$set(that.phoneForm, "IsLock", "无锁");
                  that.fullscreenLoading = false
                  // that.phoneForm.IsLock = "无锁"
                  that.$message({
                    showClose: true,
                    message: "新机信息提交成功",
                    type: "success",
                  });
                }
                if (that.phoneForm.phoneClassification === "准新机") {
                  that.scanVisible = false;
                  that.phoneForm = {};
                  that.scanBarcodeIn = "";
                  that.$set(that.phoneForm, "IsLock", "无锁");
                  // that.phoneForm.IsLock = "无锁"
                  that.fullscreenLoading = false
                  that.$message({
                    showClose: true,
                    message: "准新机信息提交成功",
                    type: "success",
                  });
                }
              });
            })
            .catch(function (error) {
              console.log(error);
            });
          // that.$message({
          //     showClose: true,
          //     message: '新机批次信息提交成功',
          //     type: 'success'
          // });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    submitScanInData() {
      var that = this;
      console.log(that.scanPhonecode, "-------scanPhonecode---------");
      const Phonecode = that.scanPhonecode.split("\n");
      Phonecode = Array.from(new Set(Phonecode));
      const onePhonecode = phoneCodeList.filter(item => item.trim() !== "");

      // console.log(Phonecode, "----------Phonecode---------");
      // Phonecode.splice(Phonecode.length - 1, 1);
      // console.log(Phonecode, "----------Phonecode---------");
      // const onePhonecode = Array.from(new Set(Phonecode));
      // console.log(onePhonecode, "onePhonecode");
      onePhonecode.forEach((element) => {
        console.log(element, "element");
        if (that.phoneForm.phoneClassification == "新机") {
          axios({
            method: "post",
            url: "openApi/app/5u91so0c1801/apply",
            data: {
              applyUser: {
                email: "",
              },
              answers: [
                {
                  queId: 182383158,
                  queTitle: "录入类型",
                  queType: 10,
                  values: [
                    {
                      value: "手机",
                    },
                  ],
                },
                {
                  queId: 182392813,
                  queTitle: "手机分类",
                  queType: 10,
                  values: [
                    {
                      value: "新机",
                    },
                  ],
                },
                {
                  queId: 182392815,
                  queTitle: "手机品牌",
                  queType: 19,
                  values: [
                    {
                      value: that.phoneForm.phoneBrand,
                    },
                  ],
                },
                {
                  queId: 182383149,
                  queTitle: "机型名称",
                  queType: 19,
                  values: [
                    {
                      value: that.phoneForm.phoneName,
                    },
                  ],
                },
                {
                  queId: 182383143,
                  queTitle: "手机颜色",
                  queType: 19,
                  values: [
                    {
                      value: that.phoneForm.phoneColor,
                    },
                  ],
                },
                {
                  queId: 182383145,
                  queTitle: "内存",
                  queType: 19,
                  values: [
                    {
                      value: that.phoneForm.phoneMemory,
                    },
                  ],
                },
                {
                  queId: 182383141,
                  queTitle: "SN码",
                  queType: 2,
                  values: [
                    {
                      value: element,
                    },
                  ],
                },
              ],
            },
            headers: {
              accessToken: "62b6c5b8-dd44-4f4e-8f95-865d45189bb3",
              "Content-Type": "application/json",
            },
          })
            .then((res) => {
              console.log(res, "res");
              // const requestID = res.data.result.requestId;
              // this.$message({
              //     showClose: true,
              //     message: '新机批次信息提交成功',
              //     type: 'success'
              // });
            })
            .catch(function (error) {
              console.log(error);
            });
        }
        if (that.phoneForm.phoneClassification == "准新机") {
          axios({
            method: "post",
            url: "openApi/app/5u91so0c1801/apply",
            data: {
              applyUser: {
                email: "",
              },
              answers: [
                {
                  queId: 182383158,
                  queTitle: "录入类型",
                  queType: 10,
                  values: [
                    {
                      value: "手机",
                    },
                  ],
                },
                {
                  queId: 182392813,
                  queTitle: "手机分类",
                  queType: 10,
                  values: [
                    {
                      value: "准新机",
                    },
                  ],
                },
                {
                  queId: 182392815,
                  queTitle: "手机品牌",
                  queType: 19,
                  values: [
                    {
                      value: that.phoneForm.phoneBrand,
                    },
                  ],
                },
                {
                  queId: 182383149,
                  queTitle: "机型名称",
                  queType: 19,
                  values: [
                    {
                      value: that.phoneForm.phoneName,
                    },
                  ],
                },
                {
                  queId: 182383143,
                  queTitle: "手机颜色",
                  queType: 19,
                  values: [
                    {
                      value: that.phoneForm.phoneColor,
                    },
                  ],
                },
                {
                  queId: 182383145,
                  queTitle: "内存",
                  queType: 19,
                  values: [
                    {
                      value: that.phoneForm.phoneMemory,
                    },
                  ],
                },
                {
                  queId: 182383141,
                  queTitle: "SN码",
                  queType: 2,
                  values: [
                    {
                      value: element,
                    },
                  ],
                },
              ],
            },
            headers: {
              accessToken: "62b6c5b8-dd44-4f4e-8f95-865d45189bb3",
              "Content-Type": "application/json",
            },
          })
            .then((res) => {
              console.log(res, "res");
              this.fullscreenLoading = false
              this.$message({
                showClose: true,
                message: "准新机信息提交成功",
                type: "success",
              });
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      });
    },
  },
};
</script>
<style scoped>
.BC-container {
  background-color: rgba(255, 235, 219, 0.27);
  display: flex;
  width: 100%;
  height: auto;
}

.BC-left-container {
  background-color: #d9ecff;
  width: 48%;
  margin: 25px;
  padding: 2%;
  border-radius: 20px;
}
.container {
  position: relative; /* 设置容器为相对定位 */
  width: 100%;
}

.floating-link {
  position: absolute; /* 绝对定位 */
  top: 10px; /* 距离容器顶部的距离 */
  right: 80px; /* 距离容器右边的距离 */
}
.BC-right-container {
  /* background-color:  #d9ecff;
    width: 100%;
    margin: 25px;
    padding: 2%;
    border-radius: 20px; */
  background-color: #FFFFFF;
  border-radius: 20px;
  height: 440px;
  width: 100%;
  flex-direction: wrap;
  display: flex;
  margin: 25px;
  padding: 2%;
  /* //border: 2px solid #c0c4cc;
  //border-radius: 20px; */
}

h3 {
  text-align: left;
}

.el-button--primary {
  color: #fff;
  background-color: #fb9337;
  border-color: #fb9337;
}

.text-right {
  text-align: right;
  /* 使内容右对齐 */
  display: flex;
  /* 如果需要的话，使用 flexbox 布局 */
  justify-content: flex-end;
  /* 使用 flexbox 的 justify-content 属性来右对齐子元素 */
  align-items: center; /* 垂直居中（如果需要） */
}
</style>



// WEBPACK FOOTER //
// src/views/BSNewPhone.vue